import { Component, ViewChildren, QueryList, OnInit } from "@angular/core";
import {
  Platform,
  IonRouterOutlet,
  AlertController,
  ModalController,
  ToastController,
  NavController,
} from "@ionic/angular";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { AppVersion } from "@awesome-cordova-plugins/app-version/ngx";
import { Network } from "@awesome-cordova-plugins/network/ngx";
import { TranslateService } from "@ngx-translate/core";

import { Router } from "@angular/router";
import { Events } from "./provider/events.service";
import { AuthService } from "./services/auth.service";
import { ApiService } from "./provider/api.service";
import { ConfigService } from "./provider/config.service";
import { endpoints } from "./constant/endpoints";
import { register } from "swiper/element/bundle";
register();
// import { DataService } from '../services/data.service';
import { stringify } from "querystring";
import { Preferences } from "@capacitor/preferences";
import { first } from "rxjs";
import * as moment from "moment";
import { DataService } from "./services/data.service";
// import { MenuPage } from './menu/menu.page';

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit {
  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;
  APP_VERSION = "1.0.0";
  settings: any = {};
  backButton = true;
  connectedToInternet: boolean = true;
  lastTimeBackPress = 0;
  timePeriodToExit = 4000;
  splash = false;

  today = moment().format("YYYY-MM-DD");
  colorprimary: any;
  colorsecondary: any;
  colortertiary: any;
  p2: any;
  s2: any;
  t2: any;
  p3: any;
  s3: any;
  t3: any;
  p4: any;
  s4: any;
  t4: any;
  shadowlight: any;
  shadowdark: any;
  shadowcolorlight: any;
  shadowcolordark: any;
  bglight: any;
  bgdark: any;
  highlight: any;
  highdark: any;
  diffuselight: any;
  diffusedark: any;
  diffuselightselected: any;
  diffusedarkselected: any;
  colorlight: any;
  colordark: any;
  colorback: any;
  colorbackdark: any;
  greenmacro: any;
  redmacro: any;
  yellowmacro: any;
  shadowhighlight: any;
  shadowhighdark: any;
  lowNutrition: any;
  highNutrition: any;
  avgNutrition: any;
  carbcolor: any;
  caloriecolor: any;
  protcolor: any;
  fatcolor: any;

  protcolorlight: string;
  fatcolorlight: string;
  carbcolorlight: string;
  caloriecolorlight: string;
  weekMenuData: any[];
  customer: any;
  daysafter: number;
  slideback: string;
  colortertiarymain: string;
  colorsecondarymain: string;
  colorprimarymain: string;
  // colors = {
  //     primary_container: '#d2a787',
  //     secondary_container: '#DFA878',
  //     tertiary_container: '#6C3428',
  //     on_primary_container: '#d2a787',
  //     on_secondary_container: '#DFA878',
  //     on_tertiary_container: '#6C3428'
  // };
  colors = {
    primary: "#35858b",
    secondary: "#4fbdba",
    tertiary: "#082227",
    on_primary: "#35858b",
    on_secondary: "#4fbdba",
    on_tertiary: "#082227",
  };
  darkermain = {
    h: 0, // Hue in degrees (0 to 360)
    s: 5, // Saturation in percentage (0 to 100)
    l: 5, // Lightness in percentage (0 to 100)
  };
  lightermain = {
    h: 0, // Hue in degrees (0 to 360)
    s: 0, // Saturation in percentage (0 to 100)
    l: 95, // Lightness in percentage (0 to 100)
  };
  white: string;
  black: string;
  light: any;
  dark: any;
  lightgrey: string;
  darkgrey: string;
  darker: string;
  grey: string;
  greyhalf: string;
  greymore: string;
  greyless: string;
  darklightgrey: string;
  darkdarkgrey: string;
  darkdarker: string;
  darkgreyhalf: string;
  darkgreymore: string;
  darkgreyless: string;
  banners: string[] = []; // Store multiple banners
  currentBannerIndex = 0; // To track the current banner index
  bannerSwitchInterval: any;
  invertPrime: string;
  invertSecond: string;
  invertTri: string;
  dtextprimary: string;
  dtextsecond: string;
  dtexttri: string;

  serverVersion: any = 0;
  splittedVersion: any;
  androidURL = "https://play.google.com/store/apps/details?id=com.dietmaster1";
  iosURL = "https://apps.apple.com/us/app/dietmaster/id1600484121";
  appPayload: any;
  days: any;
  diffusecolorselected: string;
  diffusecolor: string;
  colorprimarylighter: string;
  colorsecondarylighter: string;
  colortertiarylighter: string;
  colorprimarydeeper: string;
  colorsecondarydeeper: string;
  colortertiarydeeper: string;

  constructor(
    private router: Router,
    private dataservice: DataService,
    private platform: Platform,
    private events: Events,
    private network: Network,
    private inAppBrowser: InAppBrowser,
    private navCtrl: NavController,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private screenOrientation: ScreenOrientation,
    private authService: AuthService,
    private configService: ConfigService,
    private apiService: ApiService
  ) {}

  async initializeApp() {
    // Simulate a background task (e.g., API call or configuration load)
    await this.loadBackgroundData();
    console.log("Background data loaded");

    // Fetch authenticated user data
    const customer = await this.authService.getAuthUser();

    if (customer) {
      await this.dataservice.getMySubscription(customer.id);
      this.days = await this.dataservice.getDaysData();
    }

    setTimeout(async () => {
      let splashScreen = (document.getElementById(
        "SplashScreen"
      ).style.display = "none");
      console.log(splashScreen, "splash");
      // this.allmenu()
    }, 5000);
  }

  async ngOnInit() {
  
    this.initializeApp();

  }
  async ionViewWillEnter() {
    // await this.allmenu()
  }
  async loadBackgroundData() {
 
    this.configService.getAppSettings().then((settingData: any) => {
      this.settings = JSON.parse(settingData);
      //alert(this.settings.appLanguage);
      this.translate.setDefaultLang(this.settings.appLanguage);
      this.translate.use(this.settings.appLanguage);
      this.appUser(this.settings.currentUser);
      if (this.platform.is("capacitor")) {
        this.screenOrientation.lock(
          this.screenOrientation.ORIENTATIONS.PORTRAIT
        );
        this.checkNetworkConnection();
      }
      document.body.classList.toggle("dark", this.settings.appDarkMode);
    
    });
    this.apiService.get(endpoints.configuration).subscribe(async (response) => {
      if (response.success) {
        this.daysafter = response?.settings?.menu_selection_before
          ? Number(response?.settings?.menu_selection_before)
          : 0;
        const htmlEl = document.querySelector("html");
        if (response.data?.quote) {
          this.configService.setStorage("appQuote", response.data.quote);
        }
        // console.log(response.data.organization.configurations, 'shakir');
        this.colors.primary =
          response.data.organization.configurations.theme.primary;
        this.colors.secondary =
          response.data.organization.configurations.theme.secondary;
        this.colors.tertiary =
          response.data.organization.configurations.theme.tertiary;
        this.colors.on_primary =
          response.data.organization.configurations.theme.on_primary;
        this.colors.on_secondary =
          response.data.organization.configurations.theme.on_secondary;
        this.colors.on_tertiary =
          response.data.organization.configurations.theme.on_tertiary;

        this.lowNutrition = this.hslMake(
          this.hexToHsl(
            response.data.organization.configurations.settings
              .low_nutrition_highlight
          )
        );
        this.avgNutrition = this.hslMake(
          this.hexToHsl(
            response.data.organization.configurations.settings
              .average_nutrition_highlight
          )
        );
        this.highNutrition = this.hslMake(
          this.hexToHsl(
            response.data.organization.configurations.settings
              .high_nutrition_highlight
          )
        );

        this.caloriecolor = this.hslMake(
          this.hexToHsl(
            response.data.organization.configurations.theme.on_primary_container
          )
        );
        this.protcolor = this.hslMake(
          this.hexToHsl(
            response.data.organization.configurations.theme
              .on_secondary_container
          )
        );
        this.carbcolor = this.hslMake(
          this.hexToHsl(
            response.data.organization.configurations.theme
              .on_tertiary_container
          )
        );
        this.fatcolor = this.hslMake(
          this.hexToHsl(
            response.data.organization.configurations.theme.on_error_container
          )
        );

        this.caloriecolorlight = this.backLight(
          this.hexToHsl(
            response.data.organization.configurations.theme.on_primary_container
          )
        );
        this.protcolorlight = this.backLight(
          this.hexToHsl(
            response.data.organization.configurations.theme
              .on_secondary_container
          )
        );
        this.carbcolorlight = this.backLight(
          this.hexToHsl(
            response.data.organization.configurations.theme
              .on_tertiary_container
          )
        );
        this.fatcolorlight = this.backLight(
          this.hexToHsl(
            response.data.organization.configurations.theme.on_error_container
          )
        );

		this.p2 = this.hslMake(this.hexToHsl(response.data.organization.configurations.theme.primary));
        this.s2 = this.hslMake(this.hexToHsl(response.data.organization.configurations.theme.secondary));
        this.t2 = this.hslMake(this.hexToHsl(response.data.organization.configurations.theme.tertiary));


        // this.p3 = this.hslopacity(this.hexToHsl(response.data.organization.configurations.theme.primary), 0.5);
        // this.s3 = this.hslopacity(this.hexToHsl(response.data.organization.configurations.theme.secondary), 0.5);
        // this.t3 = this.hslopacity(this.hexToHsl(response.data.organization.configurations.theme.tertiary), 0.5);

        // this.p4 = this.hslopacity(this.hexToHsl(response.data.organization.configurations.theme.primary), 0.8);
        // this.s4 = this.hslopacity(this.hexToHsl(response.data.organization.configurations.theme.secondary), 0.8);
        // this.t4 = this.hslopacity(this.hexToHsl(response.data.organization.configurations.theme.tertiary), 0.8);

       
        // this.today = moment(this.today).add(Number(this.daysafter), 'days').format('YYYY-MM-DD');
        // this.loadMenuDataForWeek(this.today);
        // console.log(this.loadMenuDataForWeek(this.today),'weekly');

        if (this.settings.appDarkMode) {
          this.colorprimary = this.hexToHsl(this.colors.on_primary);
          this.colorsecondary = this.hexToHsl(this.colors.on_secondary);
          this.colortertiary = this.hexToHsl(this.colors.on_tertiary);

		  this.colorprimarymain = this.hslMake(
			this.hexToHsl(this.colors.on_primary)
		  );
		  this.colorsecondarymain = this.hslMake(
			this.hexToHsl(this.colors.on_secondary)
		  );
		  this.colortertiarymain = this.hslMake(
			this.hexToHsl(this.colors.on_tertiary)
		  );
  

          this.white = "#000";
          this.black = "#fff";
          this.light = "#000";
          this.dark = "#fff";

          this.lightgrey = "#484848";
          this.darkgrey = "#d2d2d2";
          this.darker = "#e3e3e3";
          this.grey = "#2c2c2c";
          this.greyhalf = "#e1e1e150";
          this.greymore = "#d4d4d475";
          this.greyless = "#9e9e9e25";
        } else {

          this.colorprimary = this.hexToHsl(this.colors.primary);
          this.colorsecondary = this.hexToHsl(this.colors.secondary);
          this.colortertiary = this.hexToHsl(this.colors.tertiary);

		  this.colorprimarymain = this.hslMake(
			this.hexToHsl(this.colors.primary)
		  );
		  this.colorsecondarymain = this.hslMake(
			this.hexToHsl(this.colors.secondary)
		  );
		  this.colortertiarymain = this.hslMake(
			this.hexToHsl(this.colors.tertiary)
		  );
  

          this.white = "#fff";
          this.black = "#000";
          this.light = '#fff';
          this.dark = '#000';

          this.lightgrey = "#e7e7e7";
          this.darkgrey = "#5a5a5a";
          this.darker = "#2c2c2c";
          this.grey = "#c1c1c1";
          this.greyhalf = "#c1c1c150";
          this.greymore = "#c1c1c175";
          this.greyless = "#c1c1c125";
        }
        //alternate colors for primary, secondary and tertiary

        // below colors only for shadows - will not work as regular variables
        this.shadowlight = this.hslShadowDark(this.colortertiary);
        this.shadowdark = this.hslShadowLight(this.colortertiary);
        this.shadowcolorlight = this.hslMakerShadow(
          this.hslShadowColorLight(this.colorprimary)
        );
        this.shadowcolordark = this.hslMakerShadow(
          this.hslShadowColorDark(this.colorprimary)
        );

        // below colors for background
        this.bglight = this.bgLight(this.colorprimary);
        this.bgdark = this.bgDark(this.colorprimary);

        // below colors for highlights
        this.highlight = this.highLight(this.colorsecondary);
        this.highdark = this.highLight(this.colorsecondary);

        // below colors for diffused transparent effects for cards,badges etc
        this.diffuselight = this.diffuseLight(this.lightermain, 0.3);
        this.diffusecolor = this.diffuseLight(this.colortertiary, 0.3);
        this.diffusedark = this.diffuseDark(this.darkermain, 0.3);
        this.diffusecolorselected = this.diffuseLight(this.colortertiary, 0.6);
        this.diffusedarkselected = this.diffuseDark(this.darkermain, 0.6);
        this.diffuselightselected = this.diffuseLight(this.lightermain, 0.6);

        this.colorprimarylighter = this.lighter(this.colorprimary);
        this.colorsecondarylighter = this.lighter(this.colorsecondary);
        this.colortertiarylighter = this.lighter(this.colortertiary);
  
        this.colorprimarydeeper = this.deeper(this.colorprimary);
        this.colorsecondarydeeper = this.deeper(this.colorsecondary);
        this.colortertiarydeeper = this.deeper(this.colortertiary);

        // below colors for text colors
        this.colorlight = this.hslColorLight(this.colorprimary);
        this.colordark = this.hslColorDark(this.colorprimary);

        this.invertPrime = this.invertHsl(this.colorprimary);
        this.invertSecond = this.invertHsl(this.colorsecondary);
        this.invertTri = this.invertHsl(this.colortertiary);

        this.dtextprimary = this.dynamicText(this.colorprimary);
        this.dtextsecond = this.dynamicText(this.colorsecondary);
        this.dtexttri = this.dynamicText(this.colortertiary);

        // below colors for svg background
        this.colorback = this.backLight(this.colorsecondary);
        this.colorbackdark = this.backDark(this.colorsecondary);

        // below colors for shadows highlighted
        this.shadowhighlight = this.hslMakerShadow(
          this.hslShadowColorLight(this.highLightShadow(this.colorsecondary))
        );
        this.shadowhighdark = this.hslMakerShadow(
          this.hslShadowColorDark(this.highLightShadow(this.colorsecondary))
        );

        // below colors for faded colors

        // below colors for main 3 this.colors.

  
		this.p3 = this.hslopacity(this.colorprimary, 0.5);
        this.s3 = this.hslopacity(this.colorsecondary, 0.5);
        this.t3 = this.hslopacity(this.colortertiary, 0.5);

        this.p4 = this.hslopacity(this.colorprimary, 0.8);
        this.s4 = this.hslopacity(this.colorsecondary, 0.8);
        this.t4 = this.hslopacity(this.colortertiary, 0.8);
        // console.log(this.colorsecondarymain);

        htmlEl.style.setProperty("--kcal", this.caloriecolor);
        htmlEl.style.setProperty("--prot", this.protcolor);
        htmlEl.style.setProperty("--carb", this.carbcolor);
        htmlEl.style.setProperty("--fat", this.fatcolor);

        htmlEl.style.setProperty("--kcal-light", this.caloriecolorlight);
        htmlEl.style.setProperty("--prot-light", this.protcolorlight);
        htmlEl.style.setProperty("--carb-light", this.carbcolorlight);
        htmlEl.style.setProperty("--fat-light", this.fatcolorlight);

        htmlEl.style.setProperty("--p3", this.p3);
        htmlEl.style.setProperty("--s3", this.s3);
        htmlEl.style.setProperty("--t3", this.t3);

        htmlEl.style.setProperty("--p4", this.p4);
        htmlEl.style.setProperty("--s4", this.s4);
        htmlEl.style.setProperty("--t4", this.t4);

        htmlEl.style.setProperty("--low-nutri", this.lowNutrition);
        htmlEl.style.setProperty("--avg-nutri", this.avgNutrition);
        htmlEl.style.setProperty("--high-nutri", this.highNutrition);

      //dm affected colors

        htmlEl.style.setProperty("--ion-color-primary", this.colorprimarymain);
        htmlEl.style.setProperty("--ion-color-secondary", this.colorsecondarymain);
        htmlEl.style.setProperty("--ion-color-tertiary", this.colortertiarymain);
  
        htmlEl.style.setProperty("--ion-light-primary", this.colorprimarylighter);
        htmlEl.style.setProperty("--ion-light-secondary", this.colorsecondarylighter);
        htmlEl.style.setProperty("--ion-light-tertiary", this.colortertiarylighter);
  
        htmlEl.style.setProperty("--ion-dark-primary", this.colorprimarydeeper);
        htmlEl.style.setProperty("--ion-dark-secondary", this.colorsecondarydeeper);
        htmlEl.style.setProperty("--ion-dark-tertiary", this.colortertiarydeeper);

        htmlEl.style.setProperty("--p2", this.p2);
        htmlEl.style.setProperty("--s2", this.s2);
        htmlEl.style.setProperty("--t2", this.t2);

        htmlEl.style.setProperty("--tprimary", this.invertPrime);
        htmlEl.style.setProperty("--tsecondary", this.invertSecond);
        htmlEl.style.setProperty("--ttertiary", this.invertTri);

        htmlEl.style.setProperty("--text-primary", this.dtextprimary);
        htmlEl.style.setProperty("--text-secondary", this.dtextsecond);
        htmlEl.style.setProperty("--text-tertiary", this.dtexttri);

        htmlEl.style.setProperty("--shadow-light", this.shadowlight); //grays only for base shadows
        htmlEl.style.setProperty("--shadow-color-light", this.shadowcolorlight); //colored shadows will be based on primary color
        htmlEl.style.setProperty("--bg-light", this.bglight); // background color will be based on primary color
        htmlEl.style.setProperty("--bg-dark", this.bgdark);
        htmlEl.style.setProperty("--highlight", this.highlight);
        htmlEl.style.setProperty("--highdark", this.highdark); //highlights colors - based on secondary color
        htmlEl.style.setProperty("--shadowhighdark", this.shadowhighdark);
        htmlEl.style.setProperty("--shadowhighlight", this.shadowhighlight); //based on the highlight color
        htmlEl.style.setProperty("--diffuse-light", this.diffuselight);
        htmlEl.style.setProperty("--diffuse-dark", this.diffusedark);
        htmlEl.style.setProperty("--diffuse-color", this.diffusecolor);
        htmlEl.style.setProperty(
          "--diffuse-color-selected",
          this.diffusecolorselected
        );
        htmlEl.style.setProperty(
          "--diffuse-light-selected",
          this.diffuselightselected
        );
        htmlEl.style.setProperty(
          "--diffuse-dark-selected",
          this.diffusedarkselected
        );
        htmlEl.style.setProperty("--ion-light", this.colorlight);
        htmlEl.style.setProperty("--ion-dark", this.colordark);
        htmlEl.style.setProperty("--colorback", this.colorback);
        htmlEl.style.setProperty("--ion-color-light", this.white);
        htmlEl.style.setProperty("--ion-color-dark", this.dark);
        htmlEl.style.setProperty("--light", this.colorlight);
        htmlEl.style.setProperty("--dark", this.colordark);
        htmlEl.style.setProperty(
          "--diffuse-selected",
          this.diffusedarkselected
        );
        htmlEl.style.setProperty("--diffuse", this.diffusedark);

        htmlEl.style.setProperty("--lightgrey", this.lightgrey);
        htmlEl.style.setProperty("--darkgrey", this.darkgrey);
        htmlEl.style.setProperty("--darker", this.darker);
        htmlEl.style.setProperty("--grey", this.grey);
        htmlEl.style.setProperty("--greyhalf", this.greyhalf);
        htmlEl.style.setProperty("--greymore", this.greymore);
        htmlEl.style.setProperty("--greyless", this.greyless);

      

        console.log(response);
        this.configService.setStorage("appPayload", response.data.organization);
        // this.appPayload = await this.configService.getStorage('appPayload');
        this.events.publish("payload:configuration", {
          appPayload: response.data.organization,
          time: new Date(),
        });
        const isDarkMode = this.settings.appDarkMode;

        console.log(this.settings);
        // await this.checkLatestVersion(response.data.organization.force_update);
        // this.backButtonEvent();
      }
    });

    this.events.subscribe("language:change", (data: any) => {
      console.log(data);
      setTimeout(() => {
        window.location.reload();
      }, 5);
    });

    this.events.subscribe("DarkMode:change", (data: any) => {
      console.log(data);
      setTimeout(() => {
        const htmlEl = document.querySelector("html");

        console.log(data);

        // if (data) {
        //   htmlEl.style.setProperty("--ion-color-primary", this.p2);
        //   htmlEl.style.setProperty("--ion-color-secondary", this.s2);
        //   htmlEl.style.setProperty("--ion-color-tertiary", this.t2);

        //   htmlEl.style.setProperty("--p2", this.colorprimarymain);
        //   htmlEl.style.setProperty("--s2", this.colorsecondarymain);
        //   htmlEl.style.setProperty("--t2", this.colortertiarymain);

        //   htmlEl.style.setProperty("--tprimary", this.invertPrime);
        //   htmlEl.style.setProperty("--tsecondary", this.invertSecond);
        //   htmlEl.style.setProperty("--ttertiary", this.invertTri);

        //   htmlEl.style.setProperty("--text-primary", this.dtextprimary);
        //   htmlEl.style.setProperty("--text-secondary", this.dtextsecond);
        //   htmlEl.style.setProperty("--text-tertiary", this.dtexttri);

        //   htmlEl.style.setProperty("--shadow-light", this.shadowlight); //grays only for base shadows
        //   htmlEl.style.setProperty(
        //     "--shadow-color-light",
        //     this.shadowcolorlight
        //   ); //colored shadows will be based on primary color
        //   htmlEl.style.setProperty("--bg-light", this.bgdark); // background color will be based on primary color
        //   htmlEl.style.setProperty("--bg-dark", this.bglight);
        //   htmlEl.style.setProperty("--highlight", this.highdark);
        //   htmlEl.style.setProperty("--highdark", this.highlight); //highlights colors - based on secondary color
        //   htmlEl.style.setProperty("--shadowhighdark", this.shadowhighlight);
        //   htmlEl.style.setProperty("--shadowhighlight", this.shadowhighdark); //based on the highlight color
        //   htmlEl.style.setProperty("--diffuse-light", this.diffusedark);
        //   htmlEl.style.setProperty("--diffuse-dark", this.diffuselight);
        //   htmlEl.style.setProperty(
        //     "--diffuse-light-selected",
        //     this.diffusedarkselected
        //   );
        //   htmlEl.style.setProperty(
        //     "--diffuse-dark-selected",
        //     this.diffuselightselected
        //   );
        //   htmlEl.style.setProperty("--ion-light", this.colordark);
        //   htmlEl.style.setProperty("--ion-dark", this.colorlight);
        //   htmlEl.style.setProperty("--colorback", this.colorbackdark);
        //   htmlEl.style.setProperty("--ion-color-light", this.black);
        //   htmlEl.style.setProperty("--ion-color-dark", this.white);
        //   htmlEl.style.setProperty("--light", this.colordark);
        //   htmlEl.style.setProperty("--dark", this.colorlight);
        //   htmlEl.style.setProperty(
        //     "--diffuse-selected",
        //     this.diffusedarkselected
        //   );
        //   htmlEl.style.setProperty("--diffuse", this.diffusedark);
        //   htmlEl.style.setProperty("--diffuse-color", this.diffusecolor);
        //   htmlEl.style.setProperty(
        //     "--diffuse-color-selected",
        //     this.diffusecolorselected
        //   );

        //   htmlEl.style.setProperty("--lightgrey", this.darklightgrey);
        //   htmlEl.style.setProperty("--darkgrey", this.darkdarkgrey);
        //   htmlEl.style.setProperty("--darker", this.darkdarker);
        //   htmlEl.style.setProperty("--grey", this.darkgrey);
        //   htmlEl.style.setProperty("--greyhalf", this.darkgreyhalf);
        //   htmlEl.style.setProperty("--greymore", this.darkgreymore);
        //   htmlEl.style.setProperty("--greyless", this.darkgreyless);
        // } else {
        //   htmlEl.style.setProperty("--p2", this.p2);
        //   htmlEl.style.setProperty("--s2", this.s2);
        //   htmlEl.style.setProperty("--t2", this.t2);

        //   htmlEl.style.setProperty(
        //     "--ion-color-primary",
        //     this.colorprimarymain
        //   );
        //   htmlEl.style.setProperty(
        //     "--ion-color-secondary",
        //     this.colorsecondarymain
        //   );
        //   htmlEl.style.setProperty(
        //     "--ion-color-tertiary",
        //     this.colortertiarymain
        //   );

        //   htmlEl.style.setProperty("--tprimary", this.invertPrime);
        //   htmlEl.style.setProperty("--tsecondary", this.invertSecond);
        //   htmlEl.style.setProperty("--ttertiary", this.invertTri);

        //   htmlEl.style.setProperty("--text-primary", this.dtextprimary);
        //   htmlEl.style.setProperty("--text-secondary", this.dtextsecond);
        //   htmlEl.style.setProperty("--text-tertiary", this.dtexttri);

        //   htmlEl.style.setProperty("--shadow-light", this.shadowdark); //grays only for base shadows
        //   htmlEl.style.setProperty(
        //     "--shadow-color-light",
        //     this.shadowcolordark
        //   ); //colored shadows will be based on primary color
        //   htmlEl.style.setProperty("--bg-light", this.bglight); // background color will be based on primary color
        //   htmlEl.style.setProperty("--bg-dark", this.bgdark);
        //   htmlEl.style.setProperty("--highlight", this.highlight);
        //   htmlEl.style.setProperty("--highdark", this.highdark); //highlights colors - based on secondary color
        //   htmlEl.style.setProperty("--shadowhighdark", this.shadowhighdark);
        //   htmlEl.style.setProperty("--shadowhighlight", this.shadowhighlight); //based on the highlight color
        //   htmlEl.style.setProperty("--diffuse-light", this.diffuselight);
        //   htmlEl.style.setProperty("--diffuse-dark", this.diffusedark);
        //   htmlEl.style.setProperty(
        //     "--diffuse-light-selected",
        //     this.diffuselightselected
        //   );
        //   htmlEl.style.setProperty(
        //     "--diffuse-dark-selected",
        //     this.diffusedarkselected
        //   );
        //   htmlEl.style.setProperty("--ion-light", this.colorlight);
        //   htmlEl.style.setProperty("--ion-dark", this.colordark);
        //   htmlEl.style.setProperty("--colorback", this.colorback);
        //   htmlEl.style.setProperty("--diffuse-color", this.diffusecolor);
        //   htmlEl.style.setProperty(
        //     "--diffuse-color-selected",
        //     this.diffusecolorselected
        //   );

        //   htmlEl.style.setProperty("--ion-color-light", this.white); //for regular
        //   // htmlEl.style.setProperty('--ion-color-light',this.black); //for pointy nail spa
        //   htmlEl.style.setProperty("--ion-color-dark", this.black);
        //   htmlEl.style.setProperty("--light", this.colorlight);
        //   htmlEl.style.setProperty("--dark", this.colordark);
        //   htmlEl.style.setProperty(
        //     "--diffuse-selected",
        //     this.diffusedarkselected
        //   );
        //   htmlEl.style.setProperty("--diffuse", this.diffusedark);

        //   htmlEl.style.setProperty("--lightgrey", this.lightgrey);
        //   htmlEl.style.setProperty("--darkgrey", this.darkgrey);
        //   htmlEl.style.setProperty("--darker", this.darker);
        //   htmlEl.style.setProperty("--grey", this.grey);
        //   htmlEl.style.setProperty("--greyhalf", this.greyhalf);
        //   htmlEl.style.setProperty("--greymore", this.greymore);
        //   htmlEl.style.setProperty("--greyless", this.greyless);
        // }

		if (data) {
			this.colorprimary = this.hexToHsl(this.colors.primary);
			this.colorsecondary = this.hexToHsl(this.colors.secondary);
			this.colortertiary = this.hexToHsl(this.colors.tertiary);
  
			this.colorprimarymain = this.hslMake(
			  this.hexToHsl(this.colors.primary)
			);
			this.colorsecondarymain = this.hslMake(
			  this.hexToHsl(this.colors.secondary)
			);
			this.colortertiarymain = this.hslMake(
			  this.hexToHsl(this.colors.tertiary)
			);
	
  
			this.white = "#000";
			this.black = "#fff";
			this.light = "#000";
			this.dark = "#fff";
  
			this.lightgrey = "#484848";
			this.darkgrey = "#d2d2d2";
			this.darker = "#e3e3e3";
			this.grey = "#2c2c2c";
			this.greyhalf = "#e1e1e150";
			this.greymore = "#d4d4d475";
			this.greyless = "#9e9e9e25";
		  } else {
  
			this.colorprimary = this.hexToHsl(this.colors.on_primary);
			this.colorsecondary = this.hexToHsl(this.colors.on_secondary);
			this.colortertiary = this.hexToHsl(this.colors.on_tertiary);
  
			this.colorprimarymain = this.hslMake(
			  this.hexToHsl(this.colors.on_primary)
			);
			this.colorsecondarymain = this.hslMake(
			  this.hexToHsl(this.colors.on_secondary)
			);
			this.colortertiarymain = this.hslMake(
			  this.hexToHsl(this.colors.on_tertiary)
			);
	
  
			this.white = "#fff";
			this.black = "#000";
			this.light = '#fff';
			this.dark = '#000';
  
			this.lightgrey = "#e7e7e7";
			this.darkgrey = "#5a5a5a";
			this.darker = "#2c2c2c";
			this.grey = "#c1c1c1";
			this.greyhalf = "#c1c1c150";
			this.greymore = "#c1c1c175";
			this.greyless = "#c1c1c125";
		  }
		  //alternate colors for primary, secondary and tertiary
  
		  // below colors only for shadows - will not work as regular variables
		  this.shadowlight = this.hslShadowDark(this.colortertiary);
		  this.shadowdark = this.hslShadowLight(this.colortertiary);
		  this.shadowcolorlight = this.hslMakerShadow(
			this.hslShadowColorLight(this.colorprimary)
		  );
		  this.shadowcolordark = this.hslMakerShadow(
			this.hslShadowColorDark(this.colorprimary)
		  );
  
		  // below colors for background
		  this.bglight = this.bgLight(this.colorprimary);
		  this.bgdark = this.bgDark(this.colorprimary);
  
      this.colorprimarylighter = this.lighter(this.colorprimary);
			this.colorsecondarylighter = this.lighter(this.colorsecondary);
			this.colortertiarylighter = this.lighter(this.colortertiary);

      this.colorprimarydeeper = this.deeper(this.colorprimary);
			this.colorsecondarydeeper = this.deeper(this.colorsecondary);
			this.colortertiarydeeper = this.deeper(this.colortertiary);
		  // below colors for highlights
		  this.highlight = this.highLight(this.colorsecondary);
		  this.highdark = this.highLight(this.colorsecondary);
  
		  // below colors for diffused transparent effects for cards,badges etc
		  this.diffuselight = this.diffuseLight(this.lightermain, 0.3);
		  this.diffusecolor = this.diffuseLight(this.colortertiary, 0.3);
		  this.diffusedark = this.diffuseDark(this.darkermain, 0.3);
		  this.diffusecolorselected = this.diffuseLight(this.colortertiary, 0.6);
		  this.diffusedarkselected = this.diffuseDark(this.darkermain, 0.6);
		  this.diffuselightselected = this.diffuseLight(this.lightermain, 0.6);
  
		  // below colors for text colors
		  this.colorlight = this.hslColorLight(this.colorprimary);
		  this.colordark = this.hslColorDark(this.colorprimary);
  
		  this.invertPrime = this.invertHsl(this.colorprimary);
		  this.invertSecond = this.invertHsl(this.colorsecondary);
		  this.invertTri = this.invertHsl(this.colortertiary);
  
		  this.dtextprimary = this.dynamicText(this.colorprimary);
		  this.dtextsecond = this.dynamicText(this.colorsecondary);
		  this.dtexttri = this.dynamicText(this.colortertiary);
  
		  // below colors for svg background
		  this.colorback = this.backLight(this.colorsecondary);
		  this.colorbackdark = this.backDark(this.colorsecondary);
  
		  // below colors for shadows highlighted
		  this.shadowhighlight = this.hslMakerShadow(
			this.hslShadowColorLight(this.highLightShadow(this.colorsecondary))
		  );
		  this.shadowhighdark = this.hslMakerShadow(
			this.hslShadowColorDark(this.highLightShadow(this.colorsecondary))
		  );
  
		  // below colors for faded colors
  
		  // below colors for main 3 this.colors.
  
	
		  this.p3 = this.hslopacity(this.colorprimary, 0.5);
		  this.s3 = this.hslopacity(this.colorsecondary, 0.5);
		  this.t3 = this.hslopacity(this.colortertiary, 0.5);
  
		  this.p4 = this.hslopacity(this.colorprimary, 0.8);
		  this.s4 = this.hslopacity(this.colorsecondary, 0.8);
		  this.t4 = this.hslopacity(this.colortertiary, 0.8);
		  // console.log(this.colorsecondarymain);
  
		  htmlEl.style.setProperty("--p3", this.p3);
		  htmlEl.style.setProperty("--s3", this.s3);
		  htmlEl.style.setProperty("--t3", this.t3);
  
		  htmlEl.style.setProperty("--p4", this.p4);
		  htmlEl.style.setProperty("--s4", this.s4);
		  htmlEl.style.setProperty("--t4", this.t4);
  
		  htmlEl.style.setProperty("--low-nutri", this.lowNutrition);
		  htmlEl.style.setProperty("--avg-nutri", this.avgNutrition);
		  htmlEl.style.setProperty("--high-nutri", this.highNutrition);
  
		//dm affected colors
  
		  htmlEl.style.setProperty("--ion-color-primary", this.colorprimarymain);
		  htmlEl.style.setProperty("--ion-color-secondary", this.colorsecondarymain);
		  htmlEl.style.setProperty("--ion-color-tertiary", this.colortertiarymain);

      htmlEl.style.setProperty("--ion-light-primary", this.colorprimarylighter);
		  htmlEl.style.setProperty("--ion-light-secondary", this.colorsecondarylighter);
		  htmlEl.style.setProperty("--ion-light-tertiary", this.colortertiarylighter);

      htmlEl.style.setProperty("--ion-dark-primary", this.colorprimarydeeper);
		  htmlEl.style.setProperty("--ion-dark-secondary", this.colorsecondarydeeper);
		  htmlEl.style.setProperty("--ion-dark-tertiary", this.colortertiarydeeper);
  
		  htmlEl.style.setProperty("--p2", this.p2);
		  htmlEl.style.setProperty("--s2", this.s2);
		  htmlEl.style.setProperty("--t2", this.t2);
  
		  htmlEl.style.setProperty("--tprimary", this.invertPrime);
		  htmlEl.style.setProperty("--tsecondary", this.invertSecond);
		  htmlEl.style.setProperty("--ttertiary", this.invertTri);
  
		  htmlEl.style.setProperty("--text-primary", this.dtextprimary);
		  htmlEl.style.setProperty("--text-secondary", this.dtextsecond);
		  htmlEl.style.setProperty("--text-tertiary", this.dtexttri);
  
		  htmlEl.style.setProperty("--shadow-light", this.shadowlight); //grays only for base shadows
		  htmlEl.style.setProperty("--shadow-color-light", this.shadowcolorlight); //colored shadows will be based on primary color
		  htmlEl.style.setProperty("--bg-light", this.bglight); // background color will be based on primary color
		  htmlEl.style.setProperty("--bg-dark", this.bgdark);
		  htmlEl.style.setProperty("--highlight", this.highlight);
		  htmlEl.style.setProperty("--highdark", this.highdark); //highlights colors - based on secondary color
		  htmlEl.style.setProperty("--shadowhighdark", this.shadowhighdark);
		  htmlEl.style.setProperty("--shadowhighlight", this.shadowhighlight); //based on the highlight color
		  htmlEl.style.setProperty("--diffuse-light", this.diffuselight);
		  htmlEl.style.setProperty("--diffuse-dark", this.diffusedark);
		  htmlEl.style.setProperty("--diffuse-color", this.diffusecolor);
		  htmlEl.style.setProperty(
			"--diffuse-color-selected",
			this.diffusecolorselected
		  );
		  htmlEl.style.setProperty(
			"--diffuse-light-selected",
			this.diffuselightselected
		  );
		  htmlEl.style.setProperty(
			"--diffuse-dark-selected",
			this.diffusedarkselected
		  );
		  htmlEl.style.setProperty("--ion-light", this.colorlight);
		  htmlEl.style.setProperty("--ion-dark", this.colordark);
		  htmlEl.style.setProperty("--colorback", this.colorback);
		  htmlEl.style.setProperty("--ion-color-light", this.white);
		  htmlEl.style.setProperty("--ion-color-dark", this.dark);
		  htmlEl.style.setProperty("--light", this.colorlight);
		  htmlEl.style.setProperty("--dark", this.colordark);
		  htmlEl.style.setProperty(
			"--diffuse-selected",
			this.diffusedarkselected
		  );
		  htmlEl.style.setProperty("--diffuse", this.diffusedark);
  
		  htmlEl.style.setProperty("--lightgrey", this.lightgrey);
		  htmlEl.style.setProperty("--darkgrey", this.darkgrey);
		  htmlEl.style.setProperty("--darker", this.darker);
		  htmlEl.style.setProperty("--grey", this.grey);
		  htmlEl.style.setProperty("--greyhalf", this.greyhalf);
		  htmlEl.style.setProperty("--greymore", this.greymore);
		  htmlEl.style.setProperty("--greyless", this.greyless);
  
		
      }, 0);
    });

    this.events.subscribe("user:login", (data: any) => {
      // const customer = this.authService.getAuthUser();
      // if (customer){
      // this.dataservice.getMySubscription(customer.id);
      // this.dataservice.getDaysData()
      // this.dataservice.getDayConfigData()
      // }
      // console.log(customer);
      console.log(data.user);
      if (data.user == null) {
        this.configService.getAppSettings().then(async (settingData: any) => {
          this.settings = JSON.parse(settingData);
          console.log(this.settings);
          this.settings.currentUser = null;
          this.configService.setStorage("appSettings", this.settings);

          try {
            const element = await this.modalCtrl.getTop();
            if (element) {
              element.dismiss();
              return;
            }
          } catch (error) {
            console.log(error);
          }
          this.authService.setAuthUser(null);
          this.authService.logOutUser();
          this.navCtrl.navigateRoot(["/onboarding"]);
        });
      }
      {
      }
    });
    // this.events.subscribe('app:update', (data: any) => {
    // 	const customer = this.authService.getAuthUser();
    // 	console.log(customer);
    // 	if (data.user == null) {
    // 		this.configService.getAppSettings()
    // 			.then(async (settingData: any) => {
    // 				this.settings = JSON.parse(settingData);
    // 				console.log(this.settings);
    // 				this.settings.currentUser = null;
    // 				this.configService.setStorage('appSettings', this.settings);
    // 				this.authService.setAuthUser(null);
    // 				this.authService.logOutUser();
    // 				this.navCtrl.navigateRoot(['/force-update']);
    // 			}
    // 			);
    // 	}
    // });

    // }, 1000);
    // });
  }

  allmenu = async () => {
    try {
      // Ensure `getDaysData` is an array and iterate over it
      //   const days = this.dataservice.getDaysData;

      if (!Array.isArray(this.days) || this.days.length === 0) {
        throw new Error("No this.days available in getthis.daysData");
      }

      // Map over the this.days and call loadData for each, collecting promises
      const promises = this.days.map((day) =>
        this.dataservice.fetchDataForDate(
          moment(day).format("YYYY-MM-DD"),
          "false"
        )
      );

      // Wait for all the promises to resolve
      const results = await Promise.all(promises);

      console.log("All menu data loaded:", results);
    } catch (error) {
      console.error("Error loading menu data:", error);
    }
  };
  checkLatestVersion = async (appData: any) => {
    const versionNumbner = this.APP_VERSION; //await this.appVersion.getVersionNumber();
    if (this.platform.is("android")) {
      const androidResponse = appData.android;
      this.androidURL = androidResponse.application_url;
      this.serverVersion = androidResponse.latest_version.split(".");
      this.splittedVersion = versionNumbner.split(".");
      //alert(this.serverVersion[0] +' - '+ this.splittedVersion[0] + ' - '+androidResponse.enabled);
      if (androidResponse.enabled) {
        this.backButton = false;
        this.appUpdate(appData.alerts.title, appData.alerts.description);
      } else if (this.serverVersion[0] > this.splittedVersion[0]) {
        //major changes
        this.backButton = false;
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text
        );
        this.events.publish("app:update", { user: null, time: new Date() });
      } else if (this.serverVersion[1] > this.splittedVersion[1]) {
        //minor changes
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.minor.description,
          appData.alerts.button_text,
          true
        );
      } else if (this.serverVersion[2] > this.splittedVersion[2]) {
        //optional changes
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
          true
        );
      }
    } else if (this.platform.is("ios")) {
      const iosResponse = appData.ios;
      //alert(versionNumbner);
      //alert(iosResponse.latest_version);
      this.iosURL = iosResponse.url;
      this.serverVersion = iosResponse.latest_version.split(".");
      this.splittedVersion = versionNumbner.split(".");
      if (iosResponse.enabled) {
        this.backButton = false;
        this.appUpdate(appData.alerts.title, appData.alerts.description);
      } else if (this.serverVersion[0] > this.splittedVersion[0]) {
        //major changes
        this.backButton = false;
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text
        );
        this.events.publish("app:update", { user: null, time: new Date() });
      } else if (this.serverVersion[1] > this.splittedVersion[1]) {
        //minor changes
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
          true
        );
      } else if (this.serverVersion[2] > this.splittedVersion[2]) {
        //optional changes
        this.appUpdate(
          appData.alerts.title,
          appData.alerts.description,
          appData.alerts.button_text,
          true
        );
      }
    }
  };
  openAppstoreEntry = async () => {
    if (this.platform.is("android")) {
      this.inAppBrowser.create(this.androidURL, "_blank");
      // NativeMarket.openStoreListing({
      //     appId: await this.appVersion.getPackageName().then(packageName => {return packageName;})
      // });
    } else if (this.platform.is("ios")) {
      this.inAppBrowser.create(this.iosURL, "_blank");
    }
  };
  appUpdate = async (header, message, buttonText = "", allowcloss = false) => {
    const buttons = [];
    if (buttonText != "") {
      buttons.push({
        text: buttonText,
        handler: () => {
          this.openAppstoreEntry();
        },
      });
    }
    if (allowcloss) {
      buttons.push({
        text: "Close",
        role: "Cancel",
      });
    }
    await this.alertCtrl
      .create({
        header,
        message,
        buttons,
        mode: "ios",
        backdropDismiss: allowcloss,
      })
      .then((alertElem) => alertElem.present());
  };
  appUser = async (currentUser: any) => {
    console.log(currentUser);

    if (
      currentUser &&
      currentUser != null &&
      window.localStorage.getItem("auth-token") != "null" &&
      window.localStorage.getItem("auth-token") != null
    ) {
      // await this.dataservice.getMySubscription(currentUser.id);
      // const customer = this.authService.getAuthUser();
      // if (customer){
      // this.dataservice.getMySubscription(customer.id);
      // this.dataservice.getDaysData()
      // this.dataservice.getDayConfigData()
      // }
    } else {
      window.localStorage.setItem("auth-token", null);
    }
  };
  backButtonEvent = () => {
    if (this.backButton) {
      this.platform.backButton.subscribeWithPriority(10, async () => {
        //try { const element = await this.alertCtrl.getTop(); if (element) { element.dismiss(); return; } } catch (error) { console.log(error); }
        try {
          const element = await this.modalCtrl.getTop();
          if (element) {
            element.dismiss();
            return;
          }
        } catch (error) {
          console.log(error);
        }
        this.routerOutlets.forEach(async (outlet: IonRouterOutlet) => {
          //alert(this.router.url);
          if (outlet && outlet.canGoBack()) {
            outlet.pop();
          } else if (
            this.router.url === "/" ||
            this.router.url === "/login" ||
            this.router.url === "/signin" ||
            this.router.url === "/tabs/menu" ||
            this.router.url === "/tabs/calendar" ||
            this.router.url === "/tabs/notifications" ||
            this.router.url === "/tabs/accounts" ||
            this.router.url === "/tabs/order"
          ) {
            if (
              new Date().getTime() - this.lastTimeBackPress <
              this.timePeriodToExit
            ) {
              await this.showConfirm();
            } else {
              await this.toastCtrl
                .create({
                  message: this.translate.instant(
                    "press_back_again_to_exit_app"
                  ),
                  duration: 4000,
                  position: "top",
                  color: "light",
                })
                .then((toastElem) => toastElem.present());
            }
            this.lastTimeBackPress = new Date().getTime();
          }
          // else if(this.router.url === '/subscription-list?historyRoute=login&landingPage=signup')
          // {
          //     alert('MD');
          // }
        });
      });
    }
  };
  checkNetworkConnection = () => {
    this.network.onDisconnect().subscribe(() => {
      this.connectedToInternet = false;
      this.translate
        .get(["Please Connect to the Internet!", "Disconnected"])
        .subscribe(async (res) => {
          let alertMsg = await this.alertCtrl.create({
            header: this.translate.instant("no_internet"),
            message: this.translate.instant("please_connect_to_the_internet"),
            mode: "ios",
            buttons: [
              {
                text: this.translate.instant("ok"),
                handler: () => {
                  navigator["app"].exitApp();
                },
              },
            ],
          });
          alertMsg.present();
        });
    });
    this.network.onConnect().subscribe(() => {
      if (!this.connectedToInternet) {
        window.location.reload();
        const customer = this.authService.getAuthUser();
        if (customer) {
          // this.dataservice.getMySubscription(customer.id);
          // this.dataservice.getDaysData()
          // this.dataservice.getDayConfigData()
        }
        this.translate
          .get(["Network connected Reloading Data", "Connected"])
          .subscribe(async (res) => {
            let alertMsg = await this.alertCtrl.create({
              header: this.translate.instant("network_found"),
              message: this.translate.instant(
                "network_connected_reloading_data"
              ),
              mode: "ios",
              buttons: [{ text: this.translate.instant("ok") }],
            });
            alertMsg.present();
          });
      }
    });
  };
  showConfirm = async () => {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant("confirm"),
      message: this.translate.instant("are_you_sure_you_want_to_exit_the_app"),
      buttons: [
        {
          text: this.translate.instant("cancel"),
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {},
        },
        {
          text: this.translate.instant("close_app"),
          handler: () => {
            navigator["app"].exitApp();
          },
        },
      ],
      //enterAnimation: customAlertEnter
    });
    await alert.present();
  };

  hexToHsl(hex) {
    hex = hex.replace(/^#/, "");

    let r = 0,
      g = 0,
      b = 0;

    // Check for shorthand hex (e.g., #abc) and expand it
    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
      // Full hex (e.g., #aabbcc)
      r = parseInt(hex.slice(0, 2), 16);
      g = parseInt(hex.slice(2, 4), 16);
      b = parseInt(hex.slice(4, 6), 16);
    } else {
      throw new Error("Invalid HEX color format");
    }

    // Convert RGB values to a range of 0 to 1
    r /= 255;
    g /= 255;
    b /= 255;

    // Find the max and min values of RGB
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;

    // Calculate Lightness
    let l = (max + min) / 2;

    let h = 0,
      s = 0;

    if (delta !== 0) {
      // Calculate Hue and Saturation only if there's no gray (delta = 0)
      // Saturation
      s = delta / (1 - Math.abs(2 * l - 1));

      // Hue
      if (max === r) {
        h = ((g - b) / delta + (g < b ? 6 : 0)) % 6;
      } else if (max === g) {
        h = (b - r) / delta + 2;
      } else if (max === b) {
        h = (r - g) / delta + 4;
      }

      h *= 60; // Convert to degrees
    }

    // Convert to percentages
    h = Math.round(h);
    s = Math.round(s * 100);
    l = Math.round(l * 100);

    return { h, s, l };
  }
  hslopacity(hsl, alpha) {
    return `hsl(${hsl.h}deg ${hsl.s}% ${hsl.l}% / ${alpha})`;
  }
  hslMake(hsl) {
    return `hsl(${hsl.h}deg ${hsl.s}% ${hsl.l}%)`;
  }

  hslMakerShadow(hsl) {
    return `${hsl.h}deg ${hsl.s}% ${hsl.l}%`;
  }

  hslShadowDark(hsl) {
    let newl = 10;
    return `${hsl.h}deg ${hsl.s}% ${newl}%`;
  }

  hslShadowLight(hsl) {
    let newl = 5;
    return `${hsl.h}deg ${hsl.s}% ${newl}%`;
  }

  hslColorDark(hsl) {
    const newS = 95;
    const newL = 3;
    return `hsl(${hsl.h}deg ${newS}% ${newL}%)`;
  }

  hslColorLight(hsl) {
    const newS = 5;
    const newL = 97;
    return `hsl(${hsl.h}deg ${newS}% ${newL}%)`;
  }

  hslShadowColorLight(hsl) {
    let newS = Math.max(hsl.s - 30, 0); // Reduce saturation
    let newL = Math.max(hsl.l - 20, 0); // Darken the shadow
    return { h: hsl.h, s: newS, l: newL };
  }

  hslShadowColorDark(hsl) {
    let newS = Math.min(hsl.s + 10, 100); // Slightly increase saturation
    let newL = Math.max(hsl.l - 50, 0); // Drastically reduce lightness
    return { h: hsl.h, s: newS, l: newL };
  }

  bgLight(hsl) {
    let s = hsl.s + (hsl.s * 10) / 100;
    let l = 97;
    const maxL = 100,
      maxS = 100,
      minS = 3,
      minL = 3;
    s = Math.max(Math.min(s, maxS), minS); // Ensure s is between minS and maxS
    l = Math.max(Math.min(l, maxL), minL);
    return `hsl(${hsl.h}deg ${s}% ${l}%)`;
  }
  lighter(hsl) {
    let l = hsl.l + (hsl.l * 25) / 100;
    l = Math.max(Math.min(l, 100), 0);
    return `hsl(${hsl.h}deg ${hsl.s}% ${l}%)`;
  }
  deeper(hsl) {
    let l = hsl.l - (hsl.l * 25) / 100;
    l = Math.max(Math.min(l, 100), 0);
    return `hsl(${hsl.h}deg ${hsl.s}% ${l}%)`;
  }

  bgDark(hsl) {
    let s = hsl.s + (hsl.s * 50) / 100;
    let l = 3;
    const maxL = 100,
      maxS = 100,
      minS = 3,
      minL = 3;
    s = Math.max(Math.min(s, maxS), minS); // Ensure s is between minS and maxS
    l = Math.max(Math.min(l, maxL), minL);
    return `hsl(${hsl.h}deg ${s}% ${l}%)`;
  }

  highLight(hsl) {
    let s = hsl.s + (hsl.s * 50) / 100;
    let l = hsl.l + (hsl.l * 25) / 100;
    const maxL = 100,
      maxS = 100,
      minS = 3,
      minL = 3;
    s = Math.max(Math.min(s, maxS), minS); // Ensure s is between minS and maxS
    l = Math.max(Math.min(l, maxL), minL);
    return `hsl(${hsl.h}deg ${s}% ${l}%)`;
  }
  highLightShadow(hsl) {
    let s = hsl.s + (hsl.s * 50) / 100;
    let l = hsl.l + (hsl.l * 25) / 100;
    const maxL = 100,
      maxS = 100,
      minS = 3,
      minL = 3;
    s = Math.max(Math.min(s, maxS), minS); // Ensure s is between minS and maxS
    l = Math.max(Math.min(l, maxL), minL);
    return { h: hsl.h, s: s, l: l };
  }

  diffuseLight(hsl, alpha) {
    let s = hsl.s + (hsl.s * 20) / 100;
    let l = hsl.l + (hsl.l * 90) / 100;
    const maxL = 100,
      maxS = 100,
      minS = 3,
      minL = 3;
    s = Math.max(Math.min(s, maxS), minS); // Ensure s is between minS and maxS
    l = Math.max(Math.min(l, maxL), minL);

    return `hsl(${hsl.h} ${s}% ${l}% / ${alpha})`;
  }

  diffuseDark(hsl, alpha) {
    let s = hsl.s - (hsl.s * 70) / 100;
    let l = hsl.l - (hsl.l * 80) / 100;
    const maxL = 100,
      maxS = 100,
      minS = 3,
      minL = 3;
    s = Math.max(Math.min(s, maxS), minS); // Ensure s is between minS and maxS
    l = Math.max(Math.min(l, maxL), minL);
    return `hsl(${hsl.h} ${s}% ${l}% / ${alpha})`;
  }

  backLight(hsl) {
    let s = hsl.s + (hsl.s * 10) / 100;
    let l = hsl.l + (hsl.l * 50) / 100;
    const maxL = 100,
      maxS = 100,
      minS = 3,
      minL = 3;
    s = Math.max(Math.min(s, maxS), minS); // Ensure s is between minS and maxS
    l = Math.max(Math.min(l, maxL), minL);
    return `hsl(${hsl.h}deg ${s}% ${l}%)`;
  }

  backDark(hsl) {
    let s = hsl.s + (hsl.s * 20) / 100;
    let l = hsl.l - (hsl.l * 90) / 100;
    const maxL = 100,
      maxS = 100,
      minS = 3,
      minL = 3;
    s = Math.max(Math.min(s, maxS), minS); // Ensure s is between minS and maxS
    l = Math.max(Math.min(l, maxL), minL);
    return `hsl(${hsl.h}deg ${s}% ${l}%)`;
  }

  invertHsl(hsl) {
    let h = (hsl.h + 180) % 360;
    let l = hsl.l < 50 ? hsl.l + 30 : hsl.l - 30;
    return `hsl(${h}deg ${hsl.s}% ${l}%)`;
  }

  dynamicText(hsl) {
    let l = hsl.l < 50 ? 100 : 0;
    console.log(l, hsl.l, "l and hsl.l");
    return `hsl(0deg 0% ${l}%)`;
  }
}
